import _en from './translations/en.json';
import _es from './translations/es.json';
export const en = _en;
export const es = _es;

// all of our translated keys will be declared here
// manually. In the future we may want to generate
// this list from the english file.
export type MessageID =
  | 'app.april'
  | 'app.august'
  | 'app.december'
  | 'app.demo'
  | 'app.demoInterpolation'
  | 'app.february'
  | 'app.id'
  | 'app.january'
  | 'app.july'
  | 'app.june'
  | 'app.march'
  | 'app.may'
  | 'app.november'
  | 'app.october'
  | 'app.september'
  | 'app.today'
  // Estimates specific messages
  | 'estimates.birthdate'
  | 'estimates.calendarYear'
  | 'estimates.code'
  | 'estimates.coinsurance'
  | 'estimates.coinsuranceDaysRemaining'
  | 'estimates.copay'
  | 'estimates.allowedCharge'
  | 'estimates.created'
  | 'estimates.date'
  | 'estimates.dateOfService'
  | 'estimates.days'
  | 'estimates.deductible'
  | 'estimates.deductibleRemaining'
  | 'estimates.description'
  | 'estimates.diagnosis'
  | 'estimates.estimate'
  | 'estimates.facility'
  | 'estimates.fax'
  | 'estimates.genericDisclaimer'
  | 'estimates.genericDisclaimerPhone'
  | 'estimates.cost'
  | 'estimates.iHaveReviewed'
  | 'estimates.inNetwork'
  | 'estimates.insuranceNumber'
  | 'estimates.insuranceNumberBenefits'
  | 'estimates.lifetime'
  | 'estimates.lifetimeReserveCoinsurance'
  | 'estimates.lifetimeReserveDaysRemaining'
  | 'estimates.max'
  | 'estimates.name'
  | 'estimates.note'
  | 'estimates.oopRemaining'
  | 'estimates.outOfNetwork'
  | 'estimates.patient'
  | 'estimates.patientCostEstimate'
  | 'estimates.patientCostEstimateOon'
  | 'estimates.patientCostEstimateOonHTML'
  | 'estimates.patientComplyCostEstimate'
  | 'estimates.patientSignature'
  | 'estimates.patientTotal'
  | 'estimates.patientTotalAfterInsurance'
  | 'estimates.payer'
  | 'estimates.pays'
  | 'estimates.phone'
  | 'estimates.physician'
  | 'estimates.plan'
  | 'estimates.primaryInsurance'
  | 'estimates.primaryInsuranceBenefits'
  | 'estimates.provider'
  | 'estimates.quantity'
  | 'estimates.secondaryInsurance'
  | 'estimates.secondaryInsuranceBenefits'
  | 'estimates.serviceLocation'
  | 'estimates.serviceYear'
  | 'estimates.subscriberID'
  | 'estimates.taxId'
  | 'estimates.tertiaryInsurance'
  | 'estimates.tertiaryInsuranceBenefits'
  | 'estimates.thisIsNotABill'
  | 'estimates.thisTreatment'
  | 'estimates.allowedTotal'
  | 'estimates.totalAllowableComply'
  | 'estimates.totalEstimatedCost'
  | 'estimates.costTotal'
  | 'estimates.treatmentHeader'
  | 'estimates.visits'
  | 'estimates.discount'
  | 'estimates.outpatientHospital'
  | 'estimates.inpatientHospital'
  //Patient Estimates messages
  | 'patientEstimate.accept'
  | 'patientEstimate.amount'
  | 'patientEstimate.amountProcessedError'
  | 'patientEstimate.billingDetails'
  | 'patientEstimate.cancel'
  | 'patientEstimate.cardNumber'
  | 'patientEstimate.clickToViewInLanguage'
  | 'patientEstimate.connectingToPaymentProcessorError'
  | 'patientEstimate.consent'
  | 'patientEstimate.consentDeclinedMessage'
  | 'patientEstimate.consentExpiredMessage'
  | 'patientEstimate.consentGrantedMessage'
  | 'patientEstimate.consentRequestMessage'
  | 'patientEstimate.creditCard'
  | 'patientEstimate.dateOfBirth'
  | 'patientEstimate.decline'
  | 'patientEstimate.differenceRefundedOrBilled'
  | 'patientEstimate.downloadEstimate'
  | 'patientEstimate.email'
  | 'patientEstimate.estimateDeletedMessage'
  | 'patientEstimate.estimateTotal'
  | 'patientEstimate.expiration'
  | 'patientEstimate.finalChargesVary'
  | 'patientEstimate.flatRate'
  | 'patientEstimate.fullAmount'
  | 'patientEstimate.invalidCardError'
  | 'patientEstimate.invalidInputError'
  | 'patientEstimate.lastFourSNN'
  | 'patientEstimate.lastFourSNNPlaceholder'
  | 'patientEstimate.lastName'
  | 'patientEstimate.lastNamePlaceholder'
  | 'patientEstimate.makeAnotherPayment'
  | 'patientEstimate.minimumDueNow'
  | 'patientEstimate.minimumPaymentDue'
  | 'patientEstimate.mustBeGreaterMessage'
  | 'patientEstimate.mustBeLessMessage'
  | 'patientEstimate.newCard'
  | 'patientEstimate.next'
  | 'patientEstimate.ofTotal'
  | 'patientEstimate.onlyAnEstimate'
  | 'patientEstimate.other'
  | 'patientEstimate.paid'
  | 'patientEstimate.pay'
  | 'patientEstimate.paymentMethodDeclinedError'
  | 'patientEstimate.paymentProcessorUnrecognizedResponse'
  | 'patientEstimate.paymentReceiptMessage'
  | 'patientEstimate.paymentReceived'
  | 'patientEstimate.payNow'
  | 'patientEstimate.pendingPaymentsMessage'
  | 'patientEstimate.phiMatchError'
  | 'patientEstimate.poweredByRivet'
  | 'patientEstimate.previouslyPaid'
  | 'patientEstimate.previousPaymentMessage'
  | 'patientEstimate.processPayment'
  | 'patientEstimate.providedPaymentInfoError'
  | 'patientEstimate.providerRequestMinimumMessageFlat'
  | 'patientEstimate.providerRequestMinimumMessageFlatBeforeService'
  | 'patientEstimate.providerRequestMinimumMessagePercent'
  | 'patientEstimate.providerRequestMinimumMessagePercentBeforeService'
  | 'patientEstimate.receipt'
  | 'patientEstimate.receiptEmailSubject'
  | 'patientEstimate.receivedAuthorizationError'
  | 'patientEstimate.remainingTotal'
  | 'patientEstimate.reopenPaymentLinkMessage'
  | 'patientEstimate.saveCard'
  | 'patientEstimate.saveCardSecurityMessageDesktop'
  | 'patientEstimate.saveCardSecurityMessageMobile'
  | 'patientEstimate.savedCards'
  | 'patientEstimate.seeYouAtAppointment'
  | 'patientEstimate.submit'
  | 'patientEstimate.thanksForPayment'
  | 'patientEstimate.totalDue'
  | 'patientEstimate.understandOnlyAnEstimate'
  | 'patientEstimate.updatePreference'
  | 'patientEstimate.upstreamPaymentProcessorError'
  | 'patientEstimate.whereShouldWeSendMessage'
  | 'patientEstimate.sms'
  | 'patientEstimate.consentEmail';

type BaseLanguage = 'en' | 'es';

// DEBUG is a special language that is useful
// for engineering and QA to detect which strings
// have and have not been translated yet on a given
// UI. All translated strings will be replaced with
// their respective messageID in the UI so that they
// are easy to find.
export type Language = BaseLanguage | 'DEBUG';

type Messages = {
  [key in MessageID]: string;
};

// This type ensures that all languages have all
// messageIds defined at compile time.
const messages: {
  [key in BaseLanguage]: Messages;
} = {
  en,
  es,
};

// getMessage retrieves a message from one of the
// language files in a type safe way. Args are
// intopolated using very simple Python-like
// interpolation syntax. `{0}` means gets replaced
// with the zero'th arg.
export function getMessage(
  id: MessageID,
  language: Language,
  ...args: (string | null)[]
): string {
  if (language == 'DEBUG') {
    return id;
  }
  const lang = messages[language];
  const message = lang[id];

  if (args.length == 0) {
    return message;
  }
  // interpolate arguments
  return message.replace(/{([0-9]+)}/g, (match, index) => args[index] ?? match);
}
